import React from 'react';
import { Card } from '../../components/ui/card';

export function AllTestsListSkeleton() {
  return (
    <main className="border-t-1 border-b-1 md:border-none py-3 px-4 md:px-2">
      <div className="flex w-full flex-col space-y-3">
        <div className="flex items-center justify-between">
          <div className="h-7 w-40 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
          <div className="h-9 w-32 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
        </div>
        <div className="grid grid-cols-2 gap-3 md:flex md:flex-nowrap">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="md:flex-shrink-0 md:max-w-[255px] w-full">
              <Card className="h-[108px] shadow-none bg-[var(--q3-surface-default)] border-l-4 border-t-2 border-b-2 border-r-2 flex flex-col justify-start gap-2 p-3">
                <div className="flex items-center justify-between">
                  <div className="h-4 w-28 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                  <div className="h-4 w-4 bg-[var(--q3-surface-dimmer)] rounded-full"></div>
                </div>
                <div className="flex flex-col gap-2">
                  <div className="h-5 w-4/5 bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                  <div className="h-4 w-full bg-[var(--q3-surface-dimmer)] rounded-md"></div>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
